var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-detail',{on:{"closeModal":function($event){return _vm.closeOrderDetail($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }